module.exports = { id: "battery", url: "/build/app/img/symbols.svg#battery", viewBox: "", toString: function() { return this.url; } };